import { useAdminResourceCheckStore } from '~~/layers/base/admin-stores/adminResourceCheck.store'

/**
 * Named route middleware: guards dynamic `/admin/:resource/*` by enabled registry + role.
 *
 * Uses `GET /api/admin/resource-check/:resource` (small O(1) response) instead of loading the
 * full resource list from `GET /api/admin/resources`. Successful checks are cached per session in
 * `useAdminResourceCheckStore` so repeat navigations to the same resource skip the round trip.
 *
 * Why: failed checks (unknown/disabled resource or insufficient role) should land at `/admin/login`
 * as the unified admin access entry point, with redirect context preserved.
 */
export default defineNuxtRouteMiddleware(async (to) => {
    const resource = String(to.params.resource ?? '').trim()
    if (!resource) {
        return
    }

    const apiBaseUrl = useApiBaseUrl()
    const checkStore = useAdminResourceCheckStore()
    try {
        /** Build fetch options in steps to avoid unctx transform issues with nested `await` args. */
        const baseOptions = apiBaseUrl ? { baseURL: apiBaseUrl } : {}
        await checkStore.ensureResourceAllowed(resource, baseOptions)
    } catch {
        return navigateTo(
            {
                path: '/admin/login',
                query: {
                    redirect: to.fullPath,
                    reason: 'forbidden',
                },
            },
            { replace: true }
        )
    }
})
